/**
 * Check if a given object implements the SelfLearningUnitGroupFilter interface.
 */
export function instanceOfSelfLearningUnitGroupFilter(value) {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "value" in value;
    return isInstance;
}
export function SelfLearningUnitGroupFilterFromJSON(json) {
    return SelfLearningUnitGroupFilterFromJSONTyped(json, false);
}
export function SelfLearningUnitGroupFilterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'value': json['value'],
    };
}
export function SelfLearningUnitGroupFilterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'value': value.value,
    };
}
